import { put, call } from 'redux-saga/effects';

import baasRequest from 'utils/baasRequest';
import { getRoleRequest } from 'utils/api/baas/workforce/roles';

import { getRole } from '../actions';

export function* handleGetRoleRequest(action) {
  const storeId = action.payload;

  try {
    yield put(getRole.request());

    const { data } = yield call(baasRequest, getRoleRequest, storeId);

    yield put(getRole.success(data));
  } catch (err) {
    yield put(getRole.failure(err));
  }
}
